import React, { useEffect, useState } from 'react';
import MDBox from 'components/MDBox';
import Grid from '@mui/material/Grid';
import {
  calculateAverageGrade,
  ProgressTabLabelValue,
  calculateAverageCompletion,
} from './SsaAcademicProgressTabUtils';
import { useSelector } from 'react-redux';
import { intialPageSize } from 'constants';
import { GridForm } from 'components/Ui/styled';
import DeltaDataGrid from 'utils/CommonDataGrid/CommonDataGrid';
import { formatDate, pageSizeChangeHandler } from 'utils/commonUtils';
import { renderCellExpand } from 'components/Common/GridCell/GridCellExpand';
import { AcademinProgressGrid } from './SsaAcademicProgressTabStyled';

const SsaAcademicProgressTab = () => {
  const selectedSsaStudentDetails = useSelector(
    (state) =>
      state?.ssaStudentDetail?.selectedSsaStudentDetails?.rawProgressData
        ?.data || []
  );

  const [academicProgressList, setAcademicProgressList] = useState({
    rows: [],
    isLoading: false,
    pageSize: intialPageSize,
  });

  useEffect(() => {
    fetchAcademicProgress();
  }, [selectedSsaStudentDetails]);

  const fetchAcademicProgress = () => {
    setAcademicProgressList((prev) => ({
      ...prev,
      rows:
        selectedSsaStudentDetails?.map((item, index) => ({
          id: index,
          courseName: item?.coursename,
          actualGrade: item?.actualgrade,
          expected: item?.percentexpected,
          overallGrade: item?.overallgrade,
          progressDate: formatDate(item?.progressdate),
          assignments: `${item?.completedassignments}/${item?.totalassignments}`,
        })) || [],
    }));
  };

  const pageSizeChange = pageSizeChangeHandler(setAcademicProgressList);

  const createColumn = (field, headerName, type = '', flex = 1) => {
    const column = {
      field,
      headerName,
      flex,
      type,
    };

    if (type !== 'boolean') {
      column.renderCell = renderCellExpand;
    }

    return column;
  };

  const columns = [
    createColumn('courseName', 'Course Name'),
    createColumn('actualGrade', 'Actual Grade'),
    createColumn('overallGrade', 'Overall Grade'),
    createColumn('expected', 'Expected'),
    createColumn('assignments', 'Assignments'),
  ];

  const totalCourses = selectedSsaStudentDetails?.length;
  const avgGrade = calculateAverageGrade(selectedSsaStudentDetails);
  const avgCompletion = calculateAverageCompletion(selectedSsaStudentDetails);

  return (
    <>
      <MDBox pt={3}></MDBox>
      <AcademinProgressGrid>
        <Grid item>
          <ProgressTabLabelValue label="Average Grade" value={`${avgGrade}%`} />
        </Grid>
        <Grid item>
          <ProgressTabLabelValue
            label="Average Completion"
            value={`${avgCompletion}%`}
          />
        </Grid>
        <Grid item>
          <ProgressTabLabelValue label="Total Courses" value={totalCourses} />
        </Grid>
      </AcademinProgressGrid>

      <GridForm container spacing={2}>
        <Grid item xs={12}>
          <DeltaDataGrid
            columns={columns}
            setListData={pageSizeChange}
            listData={academicProgressList}
          />
        </Grid>
      </GridForm>
    </>
  );
};

export default SsaAcademicProgressTab;
